import React from 'react'
import { numberFormat } from 'src/common/utils'

const DebtAmount = ({
  selectedAmount,
  handleAmountChange,
  options,
  data,
  amountFormatOptions,
}) => (
  <div>
    <h2 className="whitespace-pre-line text-center text-2xl font-bold leading-[130%] text-content-primary lg:text-heading-2">
      {data.title}
    </h2>
    <p className="mt-4 text-center text-lg font-medium leading-[120%] text-content-primary lg:mt-5 lg:text-2xl lg:leading-[130%]">
      {data.question}
    </p>
    <form className="full-width mt-4">
      <div className="relative">
        <select
          style={{ WebkitAppearance: 'none', height: '58px' }}
          id="amount"
          className="no-italic w-full rounded-lg border border-gray-230 px-4 py-2 text-base font-medium text-content-primary"
          value={selectedAmount}
          onChange={handleAmountChange}
        >
          {options.map((val) => (
            <option
              key={`vail-item-${val}`}
              className="text-blue-700"
              value={val}
            >
              {numberFormat(val, amountFormatOptions)}
            </option>
          ))}
        </select>
        <svg
          className="pointer-events-none absolute top-1/2 right-4 -translate-y-1/2"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9L12 15L18 9"
            stroke="#2F2F2F"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </form>
  </div>
)

export default DebtAmount
